import DataSkipping from './data-skipping-ext';
import { allowedCharts } from './data-skipping-charts';

function dataSkip(a) {
  a.addEventListener('preconfigure', function (a) {
    var b = a.sender,
        c = b.getFromEnv('chart');
    allowedCharts[c && c.getName()] && ('dataset' === b.getType() && 'cartesianStackGroup' !== b.getLinkedParent().getName() ? (b.setState('applySkippingOnConf', !0), DataSkipping.dataSkipping({
      component: b,
      datasetType: b.getName(),
      compType: 'dataset'
    })) : 'cartesianStackGroup' === b.getName() && (b.setState('applySkippingOnConf', !0), DataSkipping.dataSkipping({
      component: b,
      datasetType: b.getName(),
      compType: 'group'
    })));
  }), a.addEventListener('preattributeprepared', function (a) {
    var b = a.sender.getFromEnv && a.sender.getFromEnv('chart');
    if (allowedCharts[b && b.getName()]) if ('dataset' === a.sender.getType()) {
      var _b = a.sender,
          c = _b.getFromEnv('canvasConfig'),
          d = _b.getFromEnv('chart').isBar ? c.canvasHeight : c.canvasWidth;

      'cartesianStackGroup' !== _b.getLinkedParent().getName() && (_b.getState('applySkippingOnConf') ? _b.setState('applySkippingOnConf', !1) : DataSkipping.dataSkipping({
        component: _b,
        compType: 'dataset',
        datasetType: _b.getName(),
        width: d
      }));
    } else if ('cartesianStackGroup' === a.sender.getName()) {
      var _b2 = a.sender,
          _c = _b2.getFromEnv('canvasConfig'),
          _d = _b2.getFromEnv('chart').isBar ? _c.canvasHeight : _c.canvasWidth,
          e = Object.keys(_b2.getChildren())[0];

      _b2.getState('applySkippingOnConf') ? _b2.setState('applySkippingOnConf', !1) : DataSkipping.dataSkipping({
        component: _b2,
        compType: 'group',
        datasetType: _b2.getChildren(e)[0].getName(),
        width: _d
      });
    }
  }), a.addEventListener('dataplotdragend', function (a, b) {
    if (a.sender.getType && 'dataset' === a.sender.getType()) {
      var c = a.sender,
          d = c.getSkippingInfo && c.getSkippingInfo(),
          e = d && d.skippingApplied;
      e && DataSkipping.updateDragMap({
        component: c,
        compType: 'dataset',
        evenType: 'dataplotdragend',
        eventArgs: b
      });
    }
  });
}

export default {
  extension: dataSkip,
  name: 'DataSkipping',
  type: 'extension',
  requiresFusionCharts: !0
};